// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-management {
    padding: 20px;
    background-color: #2c3e50;
    border-radius: 15px;
    color: white;
  }
  
  .user-management h2 {
    margin-bottom: 20px;
    font-size: 24px;
  }
  
  .add-user, .edit-user {
    margin-bottom: 20px;
  }
  
  .add-user h3, .edit-user h3 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  
  .add-user input, .edit-user input, .add-user select, .edit-user select {
    display: block;
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #34495e;
  }
  
  .add-user button, .edit-user button {
    background-color: #e74c3c;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .add-user button:hover, .edit-user button:hover {
    background-color: #c0392b;
  }
  
  .user-list ul {
    list-style-type: none;
    padding: 0;
  }
  
  .user-list li {
    background-color: #34495e;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .ant-btn-color-dangerous.ant-btn-variant-outlined{
    color:#ffffff
  }

  button.ant-btn.css-dev-only-do-not-override-240cud.ant-btn-default.ant-btn-dangerous.ant-btn-color-dangerous.ant-btn-variant-outlined{
    background-color: #ff4d4f;
  }

  button.ant-btn.css-dev-only-do-not-override-240cud.ant-btn-default.ant-btn-dangerous.ant-btn-color-dangerous.ant-btn-variant-outlined:hover{
    background-color: #ffffff;
  }

  .user-list button {
    background-color: #e74c3c;
    color: white;
    padding: 5px 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .user-list button:hover {
    background-color: #c0392b;
  }
  
/* Добавьте эти стили к существующим */

.edit-user h3 {
  font-size: 20px;
  margin-bottom: 10px;
}

.edit-user input {
  display: block;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #34495e;
}

.edit-user button {
  background-color: #e74c3c;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.edit-user button:hover {
  background-color: #c0392b;
}

button[type="button"]{
  color: #ffffff;
}

.user-management-container {
  align-items: center;
}
/* Общее правило для иконок Ant Design */
.anticon {
  vertical-align: middle;
  line-height: auto; /* Или auto */
  
}

/* Конкретно для пагинации */
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1; 
  height: 32px; /* Подгоните под высоту вашей пагинации */
  /* Если нужно, margin / padding по вкусу */
}

.ant-pagination-item {
  /* Тоже можно указать высоту и line-height */
  line-height: 32px; 
  height: 32px;
}

.user-management-container {
  display: flex;
  justify-content: center; /* горизонтальное центрирование */
  align-items: center;     /* вертикальное центрирование, если нужно */
  flex-direction: column;  /* элементы будут идти сверху вниз */
}

/* Стили пагинации Ant Design */
.ant-pagination-item,
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  background-color: #ffffff !important; /* белый фон */
  border: 1px solid #d9d9d9 !important; /* стандартные границы AntD */
  color: rgba(0, 0, 0, 0.85) !important; /* стандартный цвет текста AntD */
}

/* Стрелки по центру внутри кнопок пагинации */
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {

  justify-content: center;
}

/* Дополнительно, стиль для активного элемента пагинации */
.ant-pagination-item-active {
  border-color: #1677ff !important;
}

.ant-pagination-next{
  display: inline-flex !important;
  align-items: flex-end;
  background-color: rgb(255, 255, 255) ;
}
.ant-pagination-prev{
  display: inline-flex !important;
  align-items: flex-end;
  background-color: rgb(255, 255, 255) ;
}

.ant-pagination-item{
  display: inline-flex !important;
  align-items: center;
  flex-wrap:nowrap;
  flex-direction:column-reverse;
  justify-content: center;
}



`, "",{"version":3,"sources":["webpack://./src/styles/UserManagement.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;AAEF,sCAAsC;;AAEtC;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,iBAAiB,EAAE,aAAa;;AAElC;;AAEA,4BAA4B;AAC5B;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY,EAAE,yCAAyC;EACvD,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,iCAAiC;EAC1D,mBAAmB,MAAM,2CAA2C;EACpE,sBAAsB,GAAG,oCAAoC;AAC/D;;AAEA,+BAA+B;AAC/B;;;EAGE,oCAAoC,EAAE,cAAc;EACpD,oCAAoC,EAAE,6BAA6B;EACnE,qCAAqC,EAAE,iCAAiC;AAC1E;;AAEA,8CAA8C;AAC9C;;;EAGE,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,qCAAqC;AACvC;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;AACzB","sourcesContent":[".user-management {\r\n    padding: 20px;\r\n    background-color: #2c3e50;\r\n    border-radius: 15px;\r\n    color: white;\r\n  }\r\n  \r\n  .user-management h2 {\r\n    margin-bottom: 20px;\r\n    font-size: 24px;\r\n  }\r\n  \r\n  .add-user, .edit-user {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .add-user h3, .edit-user h3 {\r\n    font-size: 20px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .add-user input, .edit-user input, .add-user select, .edit-user select {\r\n    display: block;\r\n    width: 100%;\r\n    padding: 10px;\r\n    margin-bottom: 10px;\r\n    border-radius: 5px;\r\n    border: 1px solid #34495e;\r\n  }\r\n  \r\n  .add-user button, .edit-user button {\r\n    background-color: #e74c3c;\r\n    color: white;\r\n    padding: 10px 15px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .add-user button:hover, .edit-user button:hover {\r\n    background-color: #c0392b;\r\n  }\r\n  \r\n  .user-list ul {\r\n    list-style-type: none;\r\n    padding: 0;\r\n  }\r\n  \r\n  .user-list li {\r\n    background-color: #34495e;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    margin-bottom: 10px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n  \r\n  .ant-btn-color-dangerous.ant-btn-variant-outlined{\r\n    color:#ffffff\r\n  }\r\n\r\n  button.ant-btn.css-dev-only-do-not-override-240cud.ant-btn-default.ant-btn-dangerous.ant-btn-color-dangerous.ant-btn-variant-outlined{\r\n    background-color: #ff4d4f;\r\n  }\r\n\r\n  button.ant-btn.css-dev-only-do-not-override-240cud.ant-btn-default.ant-btn-dangerous.ant-btn-color-dangerous.ant-btn-variant-outlined:hover{\r\n    background-color: #ffffff;\r\n  }\r\n\r\n  .user-list button {\r\n    background-color: #e74c3c;\r\n    color: white;\r\n    padding: 5px 10px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .user-list button:hover {\r\n    background-color: #c0392b;\r\n  }\r\n  \r\n/* Добавьте эти стили к существующим */\r\n\r\n.edit-user h3 {\r\n  font-size: 20px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.edit-user input {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  border-radius: 5px;\r\n  border: 1px solid #34495e;\r\n}\r\n\r\n.edit-user button {\r\n  background-color: #e74c3c;\r\n  color: white;\r\n  padding: 10px 15px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.edit-user button:hover {\r\n  background-color: #c0392b;\r\n}\r\n\r\nbutton[type=\"button\"]{\r\n  color: #ffffff;\r\n}\r\n\r\n.user-management-container {\r\n  align-items: center;\r\n}\r\n/* Общее правило для иконок Ant Design */\r\n.anticon {\r\n  vertical-align: middle;\r\n  line-height: auto; /* Или auto */\r\n  \r\n}\r\n\r\n/* Конкретно для пагинации */\r\n.ant-pagination-prev .ant-pagination-item-link,\r\n.ant-pagination-next .ant-pagination-item-link {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1; \r\n  height: 32px; /* Подгоните под высоту вашей пагинации */\r\n  /* Если нужно, margin / padding по вкусу */\r\n}\r\n\r\n.ant-pagination-item {\r\n  /* Тоже можно указать высоту и line-height */\r\n  line-height: 32px; \r\n  height: 32px;\r\n}\r\n\r\n.user-management-container {\r\n  display: flex;\r\n  justify-content: center; /* горизонтальное центрирование */\r\n  align-items: center;     /* вертикальное центрирование, если нужно */\r\n  flex-direction: column;  /* элементы будут идти сверху вниз */\r\n}\r\n\r\n/* Стили пагинации Ant Design */\r\n.ant-pagination-item,\r\n.ant-pagination-prev .ant-pagination-item-link,\r\n.ant-pagination-next .ant-pagination-item-link {\r\n  background-color: #ffffff !important; /* белый фон */\r\n  border: 1px solid #d9d9d9 !important; /* стандартные границы AntD */\r\n  color: rgba(0, 0, 0, 0.85) !important; /* стандартный цвет текста AntD */\r\n}\r\n\r\n/* Стрелки по центру внутри кнопок пагинации */\r\n.ant-pagination-prev .ant-pagination-item-link,\r\n.ant-pagination-next .ant-pagination-item-link {\r\n\r\n  justify-content: center;\r\n}\r\n\r\n/* Дополнительно, стиль для активного элемента пагинации */\r\n.ant-pagination-item-active {\r\n  border-color: #1677ff !important;\r\n}\r\n\r\n.ant-pagination-next{\r\n  display: inline-flex !important;\r\n  align-items: flex-end;\r\n  background-color: rgb(255, 255, 255) ;\r\n}\r\n.ant-pagination-prev{\r\n  display: inline-flex !important;\r\n  align-items: flex-end;\r\n  background-color: rgb(255, 255, 255) ;\r\n}\r\n\r\n.ant-pagination-item{\r\n  display: inline-flex !important;\r\n  align-items: center;\r\n  flex-wrap:nowrap;\r\n  flex-direction:column-reverse;\r\n  justify-content: center;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
